/**
 * Available layouts for external integrations
 */
export class IntegrationLayoutsEnum {
  /**
   * Default iframe integration layout
   * @type {string}
   */
  static IFRAME = 'iframe';

  /**
   * Regular website layout
   * @type {string}
   */
  static REGULAR = 'regular';
}
